import { render, staticRenderFns } from "./pay_tips.vue?vue&type=template&id=02ac6976&scoped=true"
import script from "./pay_tips.vue?vue&type=script&lang=js"
export * from "./pay_tips.vue?vue&type=script&lang=js"
import style0 from "./pay_tips.vue?vue&type=style&index=0&id=02ac6976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ac6976",
  null
  
)

export default component.exports